import React from 'react'
import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { Box, CssBaseline, Toolbar } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
import { drawerWidth, routeUrls } from 'src/utils/constants'
import styles from './index.module.scss'

import PageLoader from '../PageLoader'

import Header from './Header'
import Sidebar from './Sidebar'

const HomeLayout = () => {
  const { isAuthenticated, userInfo, token } = useSelector((state: RootState) => state.auth)
  const location = useLocation()

  if (isAuthenticated === false || !userInfo || !token) {
    return <Navigate to={routeUrls.login} state={{ from: location }} />
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <Header />

      <Sidebar />
      <Box
        component='main'
        className={styles.main}
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Outlet />
      </Box>

      <PageLoader />
    </Box>
  )
}

export default HomeLayout
